import ApiResultHelper from "@helpers/apiResult.helper";
import type IProduct from "../models/IProduct";
import LOL_API from "./lolFetcher";

const BASE_URL = "/products";

class ProductAPI {
  static getPopularProducts = async () => {
    const productRes = await LOL_API.get<IProduct[]>(`${BASE_URL}/popular`);

    return ApiResultHelper.normalizeResultLength(productRes.data);
  };

  static getProductBySlug = (slug: string) =>
    LOL_API.get<IProduct>(`${BASE_URL}/${slug}`);
}

export default ProductAPI;
